module.exports = __webpack_public_path__ + "img/satisfaction.f99f9639.svg";